import { authorizedRequest, ErrorProp } from './'
import { TEACHER_DC } from '../constants'
import { AnyUserData } from 'types'

export type ReadProps = {
  id?: string
}

export type ReadResponseProps =
  | {
      success: true
      user: Partial<AnyUserData>
    }
  | {
      success: false
      error: ErrorProp
      message?: string
    }

export async function read({ id }: ReadProps): Promise<ReadResponseProps> {
  try {
    const endpoint = `user/${id}`
    const response = await authorizedRequest({
      method: 'GET',
      endpoint,
    })
    const json = (await response.json()) as ReadResponseProps
    if (response.status === 202) {
      return {
        success: false,
        error: 'This record cannot be viewed yet. Please try again',
      }
    }
    if (json.success !== false) {
      const { user } = json
      const updatedUser = { ...user }

      if (!user?.status) {
        if (user.userType === TEACHER_DC) {
          updatedUser.status = 'teacher'
        } else {
          updatedUser.status = 'unknown'
        }
      }

      if (user?.teachingOrg !== undefined) {
        updatedUser.teachingOrg = String(user.teachingOrg)
      }

      return { success: true, user: updatedUser }
    } else {
      throw Error(json.error ?? json.message)
    }
  } catch (e: any) {
    throw e
  }
}
